import React from 'react';
import { Clock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const UpcomingReminders = ({ reminders }) => {
  const navigate = useNavigate();
  
  if (!reminders || reminders.length === 0) {
    return (
      <div className="card" style={{ background: 'white', padding: '24px', borderRadius: 'var(--border-radius-lg)', border: '1px solid var(--color-border-tertiary)', height: '100%' }}>
        <h3 style={{ fontSize: '15px', fontWeight: 'bold', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Clock size={18} color="var(--color-brand-primary)" /> Upcoming Reminders
        </h3>
        <div style={{ padding: '20px', textAlign: 'center', color: 'var(--color-text-tertiary)', fontSize: '13px' }}>
          No upcoming reminders.
        </div>
      </div>
    );
  }

  const now = new Date();
  
  const getStatusColor = (dateStr) => {
    const d = new Date(dateStr);
    if (d < now) return '#ef4444'; // Red (Overdue)
    
    // Check if today
    const isToday = d.getDate() === now.getDate() && d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
    if (isToday) return '#f59e0b'; // Yellow (Today)
    
    return '#22c55e'; // Green (Upcoming)
  };

  const getStatusLabel = (dateStr) => {
    const d = new Date(dateStr);
    if (d < now) return 'OVERDUE';
    
    const isToday = d.getDate() === now.getDate() && d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
    if (isToday) return 'TODAY';
    
    return 'UPCOMING';
  };

  return (
    <div className="card" style={{ background: 'white', padding: '24px', borderRadius: 'var(--border-radius-lg)', border: '1px solid var(--color-border-tertiary)', display: 'flex', flexDirection: 'column', height: '100%' }}>
      <h3 style={{ fontSize: '15px', fontWeight: 'bold', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Clock size={18} color="var(--color-brand-primary)" /> Upcoming Reminders
      </h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', overflowY: 'auto', flex: 1, paddingRight: '4px' }}>
        {reminders.slice(0, 5).map((reminder, idx) => {
          const color = getStatusColor(reminder.reminderAt);
          const label = getStatusLabel(reminder.reminderAt);
          
          return (
            <div key={idx} style={{ padding: '12px', borderRadius: '8px', border: '1px solid var(--color-border-tertiary)', background: 'var(--color-background-secondary)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: color }}></div>
                  <span style={{ fontSize: '11px', fontWeight: '700', color: color }}>{label}</span>
                </div>
                <span style={{ fontSize: '11px', color: 'var(--color-text-tertiary)' }}>
                  {new Date(reminder.reminderAt).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}
                </span>
              </div>
              <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '4px', cursor: 'pointer', color: 'var(--color-brand-primary)' }} onClick={() => navigate(`/lead/${reminder.leadId}`)}>
                {reminder.leadName}
              </div>
              <div style={{ fontSize: '13px', color: 'var(--color-text-secondary)', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                "{reminder.comment}"
              </div>
              {reminder.addedByName && (
                 <div style={{ fontSize: '11px', color: 'var(--color-text-tertiary)', marginTop: '6px' }}>
                   By {reminder.addedByName}
                 </div>
              )}
            </div>
          );
        })}
      </div>
      {reminders.length > 5 && (
        <div style={{ textAlign: 'center', marginTop: '16px', paddingTop: '16px', borderTop: '1px solid var(--color-border-tertiary)', fontSize: '12px', color: 'var(--color-text-secondary)' }}>
          +{reminders.length - 5} more upcoming
        </div>
      )}
    </div>
  );
};

export default UpcomingReminders;
